import { createAction, props } from '@ngrx/store';
import { IIdentityData, IIdentityModel } from '@partners/api';

export class IdentityActions {
  static reset = createAction('[Identity] Reset State');
  static updateModel = createAction('[Identity] Update Model', props<{ model: IIdentityModel }>());
  static loadFailure = createAction('[Identity] Load Failure', props<{ error: any }>());
  static submit = createAction('[Identity] Submit', props<{ model: IIdentityModel }>());
  static submitSuccess = createAction(
    '[Identity] Submit Success',
    props<{ model: IIdentityModel; data: IIdentityData }>()
  );
  static submitFailure = createAction('[Identity] Submit Failure', props<{ error: any }>());
  static loadSuccess = createAction('[Identity] Load Success', props<{ data: IIdentityData }>());
}
